export const DownloadIcon: React.FC<{ className?: string; fill?: string }> = ({ className, fill = '#1F74B6' }) => {
  return (
    <svg
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <g clipPath='url(#clip0_12891_94956)'>
        <path d='M9 2.8125V11.8125' stroke={fill} strokeWidth='1.25' strokeLinecap='round' strokeLinejoin='round' />
        <path
          d='M5.625 8.4375L9 11.8125L12.375 8.4375'
          stroke={fill}
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M17.4375 11.8125V12.9375C17.4375 13.5342 17.2004 14.1065 16.7785 14.5285C16.3565 14.9504 15.7842 15.1875 15.1875 15.1875H2.8125C2.21576 15.1875 1.64347 14.9504 1.22151 14.5285C0.799553 14.1065 0.5625 13.5342 0.5625 12.9375V11.8125'
          stroke={fill}
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_12891_94956'>
          <rect width='18' height='18' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
